import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=62283c9a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=62283c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62283c9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62283c9a')) {
      api.createRecord('62283c9a', component.options)
    } else {
      api.reload('62283c9a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=62283c9a&scoped=true&", function () {
      api.rerender('62283c9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BXS9vb2G7h7a/JS/comp/PopupBox.vue"
export default component.exports